/* section-closer-look.js — behaviour for the "Product Closer Look" section
   (sections/Testimonialimg.liquid): horizontal track with prev/next arrows, dots,
   counter and the reveal-on-scroll animation. Idempotent per root ([data-tm]); also
   re-runs on shopify:section:load for the theme editor. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    if(root.dataset.tmReady==='1') return;
    root.dataset.tmReady='1';
    var track=root.querySelector('[data-tm-track]'); if(!track) return;
    var cards=track.children, n=cards.length; if(!n) return;

    var leadZero=root.dataset.leadzero==='true';
    function pad(x){return (leadZero && x<10?'0':'')+x;}

    var prev=root.querySelector('[data-tm-prev]'),
        next=root.querySelector('[data-tm-next]'),
        dotsWrap=root.querySelector('[data-tm-dots]'),
        count=root.querySelector('[data-tm-count]');

    if(dotsWrap && !dotsWrap.children.length){
      for(var d=0;d<n;d++){
        var dot=document.createElement('i');
        if(d===0)dot.className='on';
        (function(idx){dot.addEventListener('click',function(){track.scrollTo({left:cards[idx].offsetLeft-cards[0].offsetLeft,behavior:'smooth'});});})(d);
        dotsWrap.appendChild(dot);
      }
    }
    var dots=dotsWrap?dotsWrap.querySelectorAll('i'):[];

    function step(){return cards.length>1?(cards[1].offsetLeft-cards[0].offsetLeft):cards[0].offsetWidth;}
    function active(){var c=track.scrollLeft+track.clientWidth*0.2,idx=0,best=1e9;for(var k=0;k<n;k++){var dd=Math.abs(cards[k].offsetLeft-c);if(dd<best){best=dd;idx=k;}}return idx;}
    function sync(){
      var idx=active();
      for(var k=0;k<dots.length;k++)dots[k].classList.toggle('on',k===idx);
      if(count)count.textContent=pad(idx+1)+' / '+pad(n);
      if(prev)prev.disabled=track.scrollLeft<=2;
      if(next)next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;
    }
    track.addEventListener('scroll',function(){window.requestAnimationFrame(sync);},{passive:true});
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
    window.addEventListener('resize',function(){window.requestAnimationFrame(sync);},{passive:true});
    sync();

    if(root.classList.contains('reveal')){
      if(!reduce && 'IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.18});
        for(var i=0;i<n;i++)io.observe(cards[i]);
      } else {
        for(var j=0;j<n;j++)cards[j].classList.add('in');
      }
    }
  }
  function initAll(scope){(scope||document).querySelectorAll('[data-tm]').forEach(init);}
  if(document.readyState!=='loading')initAll();
  else document.addEventListener('DOMContentLoaded',function(){initAll();});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();
